import React from 'react'

const Departments = () => {
    return (
        <div className="departments bg-red-200 flex-1">
            
        </div>
    )
}

export default Departments
